export const SoftprioFeatureName = {
  RadioQuality: "Radiokvalitet",
  UnderPerforming: 'Underpresterande',
  HeatMap: "heatmap",
  PowerSupply: "Kraftförsörjning",
  MissingTags: "Missade taggar",
  LiveStatus: "Live Status",
  DetectorSend: "detectorResend",
  TramResend: "tramResend"
}
